import { ExportToCsv } from "export-to-csv";

export default function exportCSV(columns, data) {
  const filteredColumns = columns.filter(
    (c) => typeof c.field === "string" && typeof c.title === "string"
  );
  const fields = filteredColumns.map((c) => c.field);

  const options = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    showTitle: false,
    useTextFile: false,
    useBom: true,
    headers: [...filteredColumns.map((column) => column.title)],
    filename: "report.csv",
  };

  const csvExporter = new ExportToCsv(options);

  let exportedTables = [];
  let exportedData = [];

  if (data[0].data === undefined) {
    exportedTables = data;
  } else {
    exportedData = data.map((data) => {
      return data.data;
    });

    for (let i = 0; i < exportedData.length; i++) {
      let groupHeaders = {};
      for (let j = 0; j < fields.length; j++) {
        groupHeaders[fields[j]] = data[i].value;
      }
      exportedTables = exportedTables.concat(groupHeaders);
      exportedTables = exportedTables.concat(exportedData[i]);
    }
  }
  csvExporter.generateCsv(
    exportedTables.map((row) => fields.map((f) => row[f]))
  );
}
